import { render, staticRenderFns } from "./SingleNoteLoading.vue?vue&type=template&id=49156cd8&scoped=true&"
import script from "./SingleNoteLoading.vue?vue&type=script&lang=js&"
export * from "./SingleNoteLoading.vue?vue&type=script&lang=js&"
import style0 from "./SingleNoteLoading.vue?vue&type=style&index=0&id=49156cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49156cd8",
  null
  
)

component.options.__file = "SingleNoteLoading.vue"
export default component.exports